import React from 'react';
import { Grid } from '@mui/material';
import moment from 'moment';
import 'moment-timezone';
import { CourseSessionOut } from '../../../../api';
import { OrderPageTypography } from '../../../themedComponents/OrderPageTypography';

const CourseSessionsList = ({
  courseSessions,
  longDateFormat,
  timeFormat,
  duration,
}: {
  courseSessions: CourseSessionOut[];
  longDateFormat: string;
  timeFormat: string;
  // when given, each session shows a time range instead of just its start time
  duration?: number;
}) => {
  const allSessionsShareTime = courseSessions.every((session) => session.time === courseSessions[0].time);

  return (
    <Grid container flexDirection="column" gap={allSessionsShareTime ? 0.5 : 1.5} mt={1.5}>
      {courseSessions.map((session: CourseSessionOut, index: number) => (
        <Grid container flexDirection="column" key={index}>
          <OrderPageTypography variant="h6">{moment(session.date).format(longDateFormat)}</OrderPageTypography>
          {!allSessionsShareTime && (
            <Grid dir="ltr">
              <OrderPageTypography variant="body2" color="border">
                {duration
                  ? `${moment.unix(session.time).tz('utc').format(timeFormat)} – ${moment
                      .unix(session.time)
                      .tz('utc')
                      .add(duration, 'seconds')
                      .format(timeFormat)}`
                  : moment.unix(session.time).tz('utc').format(timeFormat)}
              </OrderPageTypography>
            </Grid>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default CourseSessionsList;
